export const mapRefundImagesToBase64 = (urls: string[]) => urls.map((url: string) => `data:image/png;base64,${url}`);

export const fetchReturnDetailRefundImages = async (urlList: string[], getRefundImages: (params: any) => Promise<any>) => {
    const params = { urlList };
    const res = await getRefundImages(params);
    if (!res) {
        return [];
    }
    return mapRefundImagesToBase64(res);
};
